(function ($) {
    $(function () {
        $(document).click(function (e) {
            var container = $(".menu-bar-active");

            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.button--menu').removeClass('button--menu-active')
                $('.menu-bar').removeClass('menu-bar-active')
                $('.navigation').removeClass('has-more-z-index');
            }
        });

        $('.button--menu').click(function (e) {
            e.stopPropagation();

            $(this).toggleClass('button--menu-active');
            $('.menu-bar').toggleClass('menu-bar-active');
            $('.navigation').toggleClass('has-more-z-index');
        });


    });
})(jQuery);